// extracted by mini-css-extract-plugin
export var formField = "subscription-form-module--formField--93304";
export var formFields = "subscription-form-module--formFields--f4f50";
export var heading = "subscription-form-module--heading--044b7";
export var legalCopy = "subscription-form-module--legalCopy--163ff";
export var message = "subscription-form-module--message--c187a";
export var root = "subscription-form-module--root--91ad9";
export var rootPopup = "subscription-form-module--rootPopup--0ee4a";